import { connect } from 'react-redux';
import { withHandlers, compose } from 'recompose';
import { withRouter } from 'react-router';

import { fetchSelectedServices } from '../services/actions';
import { getBarbers, getBarbersCount } from './selectors';
import WithServiceDuration from '../hoc/WithServiceDuration';
import FetchOnMount from '../hoc/FetchOnMount';
import WithLoader from '../hoc/WithLoader';
import Barbers from './components/Barbers';
import { fetchShop } from '../shops/actions';
import { fetchBarbersWithNextAvailableTime } from './actions';
import { getShopByRoute, getAllowBookWithAnyBarber } from '../shops/selectors';
import { generateUrlString } from '../utils/helpers';
import withKioskProp from '../hoc/WithKioskProp';
import WithShop from '../hoc/WithShop';

function mapStateToProps(state, ownProps) {
  return {
    barbers: getBarbers(state, ownProps.params),
    shop: getShopByRoute(state, ownProps.params.shopRoute),
    allowBookWithAnyBarber:
      getBarbersCount(state, ownProps.params) > 1 && getAllowBookWithAnyBarber(state, ownProps.params.shopRoute),
    generateUrlString: params => generateUrlString(
      { ...ownProps.params, ...params },
      ownProps.urlPattern
    ),
  };
}

const mapDispatchToProps = {
  fetchShopAction: fetchShop,
  fetchServiceAction: fetchSelectedServices,
  fetchBarbersWithNextAvailableTimeAction: fetchBarbersWithNextAvailableTime,
};

export default compose(
  withKioskProp,
  WithServiceDuration,
  WithShop,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    fetchShop: props => () => props.fetchShopAction(
      props.params.shopRoute,
      props.urlPattern
    ),
    fetchService: props => () => props.fetchServiceAction(
      props.params.shopRoute,
      null,
      props.params.serviceId,
      props.params,
      props.urlPattern
    ),
    fetchBarbersWithNextAvailableTime: props => () => props.fetchBarbersWithNextAvailableTimeAction(
      props.params.shopRoute,
      props.params,
      props.urlPattern,
      props.serviceDuration,
      props.kiosk,
    ),
  }),
  withHandlers({
    fetchData: props => () =>
      props.fetchShop()
        .then(() => props.fetchService())
        .then(() => props.fetchBarbersWithNextAvailableTime()),
  }),
  FetchOnMount,
  WithLoader,
)(Barbers);



// WEBPACK FOOTER //
// ./src/app/barbers/Barbers.jsx